import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from '../styles'
import { Icon } from '@iconify/react'
import { CoreButton } from 'src/components/core'

const MailSent = props => {
  const { closeDrawer, classes, handleBack } = props
  return (
    <>
      <div className={classes.mailSent__header}>
        <Icon icon={'material-symbols:mail-outline'} width={20} height={20} />
        <Typography fontSize={'15px'} fontWeight={600}>
          Send Magic Link by Email
        </Typography>
      </div>
      <div className={classes.mailSent__header__icon}>
        <img
          src={'/assets/done_img.png'}
          alt={'mail-sent'}
          width={100}
          height={100}
        />
        <Typography textAlign={'center'} fontSize="20px" fontWeight={600}>
          Your delivery has been done!
        </Typography>
        <Typography
          textAlign={'center'}
          fontSize="14px"
          fontWeight={400}
          color="#637381"
        >
          We intend to employ your collection name along with a concise,
          <br />
          uninterrupted link tailored specifically for the group or individual
          <br />
          learner within the groups you've chosen.
        </Typography>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          gap: 16,
        }}
      >
        <CoreButton
          size="small"
          variant={'contained'}
          onClick={() => handleBack()}
          color="disabled"
        >
          Back
        </CoreButton>
      </div>
    </>
  )
}

export default withStyles(styles)(MailSent)
